import { definePreset } from '@primeng/themes';
import Lara from '@primeng/themes/lara';

const PrimePresset = definePreset(Lara, {
  components: {
    menubar: {
      css: () => `
            .p-menubar {padding-left: 9%;}
            `,
    },
    confirmdialog: {
      css: () => `
        .p-confirmdialog-message .p-confirmdialog-message-header {
          padding: 1rem;
        }
        .p-confirmdialog-message .p-confirmdialog-message-content {
          padding: 0;
        }
      `,
    },
    button: {
      css: () => `
        .p-confirmdialog-reject-button {
          background: #FF5A4E;
          border-color: #FF5A4E;
        }

        .p-confirmdialog-reject-button:not(:disabled):hover {
          background: #eb1000;
          border-color: #eb1000;
        }

        .download-button .p-button-label {
          display: none;
        }

        .upload-button .p-button-label {
          display: none;
        }

        .download-button .p-button {
          min-width: 3rem;
          width: 3rem;
          height: 3rem;
          padding: 0;
        }

        .upload-button .p-button.p-fileupload-choose-button {
          min-width: 3rem;
          width: 3rem;
          height: 3rem;
          padding: 0;
        }
      `,
    },
    tree: {
      css: () => `
        .p-tree{
          padding: 0;
        }
      `,
    },
  },
  semantic: {
    colorScheme: {
      light: {
        primary: {
          color: '#92c13b',
          inverseColor: '#ffffff',
          hoverColor: '#76A52B',
          activeColor: '#76A52B',
        },
      },
    },
  },
});

export default PrimePresset;
